import { useEffect, useState } from 'react';

import { addListener, launch } from 'devtools-detector';

import { reportUserViolation } from '../api/user/user.api';
import { isDev } from '../helpers';
import { logErrorMini } from '../services/service-logger/lib/log-error-mini';
import { useFeatureFlag } from './use-feature-flag';

export const useDevtoolsLocker = () => {
  const { isKassir, isTestUser } = useFeatureFlag();
  const [isViolationReported, setIsViolationReported] = useState<boolean>(false);

  const reportViolation = async () => {
    try {
      setIsViolationReported(true);
      await reportUserViolation({ isConsoleOpened: true });
    } catch (error) {
      void logErrorMini(error as Error, 'reportViolation');
    }
  };

  useEffect(() => {
    if (!import.meta.env.PROD) {
      return;
    }

    addListener((isOpen) => {
      // eslint-disable-next-line no-constant-condition
      if (isOpen && !isViolationReported && false) {
        void reportViolation();
      }
    });
  }, [isViolationReported]);

  useEffect(() => {
    if (isDev('both')) return;

    if (!isKassir && !isTestUser) {
      launch();
    }
  }, [isKassir, isTestUser]);
};
